import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import { CookieStorage } from "cookie-storage";
import defaultSecure from "./defaultSecure/index.js";
export const SESSION_TOKEN = 'xo-session-token';
const DOMAIN = '.theknot.com';
const SESSION_TOKEN_DAYS_TO_LIVE = 30;
/* days */

const daysInTheFuture = offset => {
  const date = new Date();
  date.setDate(date.getDate() + offset);
  return date;
};

const cookieConfig = {
  internal: {
    secure: defaultSecure(),
    sameSite: 'Lax',
    cookieName: SESSION_TOKEN,
    cookieExpiration: SESSION_TOKEN_DAYS_TO_LIVE
  },
  external: {
    secure: true,
    sameSite: 'None',
    cookieName: 'xo-cross-site-session-token',
    cookieExpiration: 7
    /* days */

  }
};

const createCookieStorage = _ref => {
  let {
    secure,
    sameSite
  } = _ref;
  const options = {
    path: '/',
    domain: process.env.UNION_MEMBERSHIP_COOKIE_DOMAIN || DOMAIN,
    secure,
    sameSite
  };
  return new CookieStorage(options);
};

export default class MembershipBrowserPersistence {
  constructor() {
    let {
      useExternalCookieConfig = false,
      storage
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const cookieOptions = useExternalCookieConfig ? cookieConfig.external : cookieConfig.internal;
    this.storage = storage || createCookieStorage({
      secure: cookieOptions.secure,
      sameSite: cookieOptions.sameSite
    });
    this.sessionTokenCookie = cookieOptions.cookieName;
    this.sessionTokenExpiration = cookieOptions.cookieExpiration;
  }

  onLogIn(_ref2) {
    let {
      token,
      tokenExpirationDate = daysInTheFuture(this.sessionTokenExpiration)
    } = _ref2;

    if (_globalThis.UnionConsentManagement) {
      _globalThis.UnionConsentManagement.onConsentedToNecessary(() => {
        this.storage.setItem(this.sessionTokenCookie, token, {
          expires: tokenExpirationDate
        });
      });
    } else {
      this.storage.setItem(this.sessionTokenCookie, token, {
        expires: tokenExpirationDate
      });
    }
  }

  getBrandVersion() {
    return this.storage.getItem('tk_catalyst_variant') === 'b01' ? '2023.1' : null;
  }

  getSessionToken() {
    return this.storage.getItem(this.sessionTokenCookie);
  }

  deleteSessionToken() {
    return this.storage.removeItem(this.sessionTokenCookie);
  }

}